module.exports = __webpack_public_path__ + "static/img/2.96d6450.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/2.png
// module id = t20G
// module chunks = 0